import React, {useEffect} from 'react';
import {useNavigate} from "react-router-dom";
import {useAppSelector} from "../../store/hooks";
import LoginForm from "./login/LoginForm";
import Wrapper from "../Wrapper";

const Login = () => {
    const navigate = useNavigate()
    const authUser = useAppSelector(state => state.auth.authUser)

    useEffect(() => {
        if (authUser) {
            navigate('/')
        }
    }, [authUser])

    return (
        <Wrapper>
            <div className="">
                <LoginForm />
            </div>
        </Wrapper>
    );
};

export default Login;